import Dialog from "../../atoms/dialog";
import { Button, Typography, Box } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import DeleteSensor from "../sensors/DeleteSensor";



const DeleteSensorAlert = (props) => {
    const { onCompletion, setShowDeleteAlert, element, onClose } = props;


    const [open, setOpen] = useState(false)


    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (

        <Dialog
            open={true}
            handleClose={handleClose}
        >

            <DeleteSensor onCompletion={onCompletion} setShowDeleteAlert={setShowDeleteAlert} element={element} onClose={onClose} />

        </Dialog >
    )

}

export default DeleteSensorAlert;